var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPldBuilding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 3.5a.75.75 0 00-.75.75V20.5h2v-2.75c0-.69.56-1.25 1.25-1.25h6.5c.69 0 1.25.56 1.25 1.25v2.75h2v-8.75a.75.75 0 00-.75-.75h-2a.75.75 0 01-.75-.75v-6a.75.75 0 00-.75-.75h-8zM9 18v2.5h2.25V18H9zm3.75 0v2.5H15V18h-2.25zm6.5 4H4.75a.75.75 0 01-.75-.75v-17A2.25 2.25 0 016.25 2h8a2.25 2.25 0 012.25 2.25V9.5h1.25A2.25 2.25 0 0120 11.75v9.5a.75.75 0 01-.75.75zM7.5 6.5a1 1 0 112 0 1 1 0 01-2 0zm1 6a1 1 0 100 2 1 1 0 000-2zm0-3.5a1 1 0 100 2 1 1 0 000-2zM12 5.5a1 1 0 100 2 1 1 0 000-2zm0 7a1 1 0 100 2 1 1 0 000-2zm3.5 0a1 1 0 100 2 1 1 0 000-2zM12 9a1 1 0 100 2 1 1 0 000-2z",
    fill: "#333230"
  })));
}
export default SvgPldBuilding;